import { JSX } from "react";
import { ProductSpecificationEntry } from "../../../../utils/productDetail/buildProductSpecificationEntries";
import { PRODUCT_SPEC_COLUMN_COUNT } from "../../../../utils/productDetail/productSpecificationsConstants";
import { ProductDetailColumnGrid } from "../shared/ProductDetailColumnGrid";
import { ProductSpecificationItem } from "./ProductSpecificationItem";

interface Props {
    entries: ProductSpecificationEntry[];
}

export const ProductSpecificationsGrid = ({ entries }: Props): JSX.Element => {
    const items = entries.map((entry) => (
        <ProductSpecificationItem key={entry.key} entry={entry} />
    ));

    return (
        <ProductDetailColumnGrid
            items={items}
            columnCount={PRODUCT_SPEC_COLUMN_COUNT}
        />
    );
};
